export default {
  title: 'Quote Offer Expired',
  description:
    'Sorry, the price offers have expired. Please click here to get new price offers.',
  confirmButton: 'Home Page',
} as const
